import React, { useContext } from 'react'
import { WorkModel } from '@Entities/work/work'
import WorkItem from '@Components/WorkItem'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
interface WorkItemListProps {
    workItems: WorkModel[]
    selectWork: (songCode: string, title: string) => void
}

/**
 * @deprecated Use WorkResultsCardTable instead
 */
const WorkItemList = (props: WorkItemListProps) => {
    const { rightsholderStore } = useContext(StoresContext)
    const { workItems, selectWork } = props

    return (
        <>
            {workItems.map((work) => (
                <WorkItem
                    publicSearchType
                    data={work}
                    key={work.id ? work.id : ''}
                    selectWorkForMatching={selectWork}
                    rightsHolderId={rightsholderStore.optionalCurrentRightsholderId}
                />
            ))}
        </>
    )
}

export default observer(WorkItemList)
